import { render, staticRenderFns } from "./NewPaymentMethodModal.vue?vue&type=template&id=150757b9&scoped=true&"
import script from "./NewPaymentMethodModal.vue?vue&type=script&lang=js&"
export * from "./NewPaymentMethodModal.vue?vue&type=script&lang=js&"
import style0 from "./NewPaymentMethodModal.vue?vue&type=style&index=0&id=150757b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150757b9",
  null
  
)

export default component.exports